// @flow
// @deprecated, use FormattedPlural or FormattedMessage from react-intl v6 instead.
export { default as Param } from './Param';
export { default as Plural } from './Plural';
export { default } from './FormattedCompMessage';
